import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StartAnalysisRequest, StartAnalysisResponse, ChatSessionDTO, ClientChatSummary } from '@core/models/chat.models';
import { AnalysisResponse } from '@core/models/analysis.models';

export interface ApiResponse<T> {
  exito: boolean;
  mensaje: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class AnalysisService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  startAnalysis(request: StartAnalysisRequest): Observable<StartAnalysisResponse> {
    return this.http.post<StartAnalysisResponse>(
      `${this.apiUrl}/analysis/start`,
      request
    );
  }

  getChatSession(chatId: string): Observable<ChatSessionDTO> {
    return this.http.get<ChatSessionDTO>(
      `${this.apiUrl}/chat/${chatId}`
    );
  }

  getChatBySolicitud(solicitudId: string): Observable<ChatSessionDTO> {
    return this.http.get<ChatSessionDTO>(
      `${this.apiUrl}/chat/solicitud/${solicitudId}`
    );
  }

  sendMessage(chatId: string, message: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/test/entrevistador/${chatId}/message`,
      { message }
    );
  }

  getAnalysis(solicitudId: string): Observable<AnalysisResponse> {
    return this.http.get<AnalysisResponse>(
      `${this.apiUrl}/analysis/${solicitudId}`
    );
  }

  getClientChats(): Observable<ClientChatSummary[]> {
    return this.http.get<ClientChatSummary[]>(
      `${this.apiUrl}/chat/cliente/mis-chats`
    );
  }
}
